// Content-Type is a CORS-safelisted header and therefore always readable, unlike
// Content-Disposition - use it to pick the extension of the fallback filename.
const extensions = {
    "application/pdf"                                                        : "pdf",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"      : "xlsx",
    // reports-svc sends this type for its xlsx exports (rep.T_RP_E_FORMAT)
    "application/vnd.ms-excel"                                               : "xlsx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/msword"                                                     : "doc",
    "text/csv"                                                               : "csv",
    "application/csv"                                                        : "csv",
    "text/calendar"                                                          : "ics",
    "application/zip"                                                        : "zip",
};

export const extensionFrom = (contentType) => {
    const type = (contentType || "").split(";")[0].trim().toLowerCase();
    return extensions[type];
}

// Parses an RFC 6266 Content-Disposition header. The RFC 5987 filename* carries names with
// umlauts and wins over filename, whose quoted value may only be an ASCII or "=?UTF-8?Q?" fallback.
export const filenameFromHeader = (header) => {
    if (!header) {
        return null;
    }

    const extended = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (extended) {
        try {
            return decodeURIComponent(extended[1].trim());
        } catch (e) {
            // malformed percent-encoding - try the plain filename below
        }
    }

    const quoted = header.match(/filename\s*=\s*"((?:\\.|[^"\\])*)"/i);
    if (quoted) {
        return quoted[1].startsWith("=?") ? null : quoted[1].replace(/\\(.)/g, "$1");
    }

    const token = header.match(/filename\s*=\s*([^";]+)/i);
    return token ? token[1].trim() : null;
}

// Content-Disposition is only readable here if the backend exposes it via
// Access-Control-Expose-Headers on cross-origin responses - fall back to a generic name
// instead of throwing when it's missing, so the download still happens.
export const filenameFrom = (response, fallbackName, fallbackExtension) => {
    const filename = filenameFromHeader(response.headers.get("Content-Disposition"));
    if (filename) {
        return filename;
    }

    console.warn("Download: no Content-Disposition filename, falling back to a generic name", response.url);
    const extension = extensionFrom(response.headers.get("Content-Type")) || fallbackExtension;
    return extension ? fallbackName + "." + extension : fallbackName;
}
